import { render } from "./breadcrumbs.vue?vue&type=template&id=b439a4b0"
import script from "./breadcrumbs.vue?vue&type=script&lang=js"
export * from "./breadcrumbs.vue?vue&type=script&lang=js"

import "./breadcrumbs.vue?vue&type=style&index=0&id=b439a4b0&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__